//|---------------------------------------------------------------------|
//|                                                                     |
//|                       Abandon All Hope                              |
//|                                                                     |
//|                      Ye Who Debug Here                              |
//|                                                                     |
//|---------------------------------------------------------------------|
import QuestionResult from "../QuestionResult";
import resultListStyles from "@educaplay/core/GameProvider/GameProviderScore/Results/Results.module.scss";

export default function ResultsScreen(props) {
  const { questions } = props;
  return (
    <div className={resultListStyles.container}>
      {questions.map((question) => (
        <QuestionResult
          key={question.id}
          question={question}
          questionNumber={question.id}
        />
      ))}
    </div>
  );
}
